import './CardContact.css';
import SvgEmail from '../../../svg/Email';
import SvgPhone from '../../../svg/Phone';

import { useSelector } from 'react-redux';
import { translate } from '../../../i18n';
import { RootState } from '../../../store';
import axios from 'axios';

interface ICardContactProps {
    id: number;
    userId: number;
    name: string;
    positionEnglish: string;
    positionFrench: string;
    phoneFrench: string;
    phoneEnglish: string;
    emailFrench: string;
    emailEnglish: string;
}
const CardContact: React.FC<ICardContactProps> = (props) => {
    const { language } = useSelector((state: RootState) => state.lang);

    const [position, phone, email] = language === 'EN' ? [props.positionEnglish, props.phoneEnglish, props.emailEnglish] : [props.positionFrench, props.phoneFrench, props.emailFrench];

    return (
        <button key={props.id} className="ContactsCardOuter Drop-Shadow">
            <div className="ContactsCardTop">
                <div className="ContactsCardName">{props.name}</div>
                <div className="ContactsCardTitle">{position}</div>
            </div>
            <div className="ContactsCardBottom">
                <div
                    className="ContactsCardInfo"
                    style={{
                        visibility: phone ? 'visible' : 'hidden'
                    }}
                >
                    <div className="ContactsCardIcon">
                        <SvgPhone width={'2.5rem'} height={'2.5rem'} color="#424559" />
                    </div>
                    {phone}
                </div>
                <div
                    className="ContactsCardInfo"
                    style={{
                        visibility: email ? 'visible' : 'hidden'
                    }}
                >
                    <div className="ContactsCardIcon">
                        <SvgEmail width={'2.5rem'} height={'2.5rem'} color="#424559" />
                    </div>
                    {email}
                </div>
            </div>
        </button>
    );
};

export default CardContact;
